import type { IntlShape } from 'react-intl';
import type { Dispatch } from 'redux';

import { config } from '../config';
import type { RootState } from '../configuration/setup/store';
import { actions } from './actions';
import { fetchPoi } from './fetchPoi';
import { fetchAssetsAndDriversWithStates } from './fetchStates';

export const FALLBACK_DATA_POLL_INTERVAL = 400;

const startPolling = (() => {
    let timeout: NodeJS.Timeout;

    return (intl: IntlShape) => (dispatch: Dispatch, getState: () => RootState) => {
        const poll = () => {
            const pollInterval = config.backend.POLL_INTERVAL;

            dispatch(fetchAssetsAndDriversWithStates(intl));
            timeout = setTimeout(poll, pollInterval || FALLBACK_DATA_POLL_INTERVAL);
        };

        clearTimeout(timeout);
        poll();
    };
})();

export const fetchInitialData = (intl: IntlShape) => (dispatch: Dispatch) => {
    dispatch(actions.fetchInitialDataRequested());
    dispatch(startPolling(intl));
    dispatch(actions.fetchInitialDataSuccess());
    dispatch(fetchPoi);
};
